import { WizardPersistedState } from "../types";
import { WizardAction } from "./types";

export const initialWizardState: WizardPersistedState = {
  completedSteps: [],
  skippedSteps: [],
  wizardCompleted: false,
  startedAt: new Date().toISOString(),
};

export function wizardReducer(
  state: WizardPersistedState,
  action: WizardAction,
): WizardPersistedState {
  switch (action.type) {
    case "COMPLETE_STEP": {
      if (state.completedSteps.includes(action.stepId)) {
        return state;
      }

      return {
        ...state,
        completedSteps: [...state.completedSteps, action.stepId],
        skippedSteps: state.skippedSteps.filter(
          id => id !== action.stepId,
        ),
      };
    }

    case "SKIP_STEP": {
      if (state.skippedSteps.includes(action.stepId)) {
        return state;
      }

      return {
        ...state,
        skippedSteps: [...state.skippedSteps, action.stepId],
      };
    }

    case "COMPLETE_WIZARD":
      return { ...state, wizardCompleted: true };

    case "HYDRATE":
      return action.payload;

    case "RESET":
      return action.payload;

    default:
      return state;
  }
}
